const Page: React.FC<React.PropsWithChildren<{ className?: string }>> = ({
  className,
  children,
}) => {
  return (
    <div
      className={`mx-auto flex max-w-[1070px] flex-col items-start px-2.5 md:flex-row lg:px-0 ${className}`}
    >
      {children}
    </div>
  );
};

export default Page;
